export const BOUNDARIES_API = '/api/v1/boundaries';
